'use strict';
;(function($, window){

	var timerVar;	
	var isALARendered;
	var HeaderTop = 0;

	$(document)
	.on('shopify:section:load', sectionEdit)
	.on('shopify:section:unload', sectionEdit)
	.on('shopify:section:select', sectionEdit)
	.on('shopify:section:deselect', sectionEdit)
	.on('shopify:block:select', blockEdit)
	.on('shopify:block:deselect', blockEdit);

	$(document).ready(function(){		
		sectionReady();
		navbarClick();
		promobar();
		menu();
		mobileNav();
		stuckNav();
		expanderList();
		collapseBlock();
		backToTop();
		videoPlay();
		noellaPlay();
		setReviews();
		ALAcheck();
		productCarousel($('.megaMenuCarousel_js'),true);
		productCarousel($('#mobileGallery'),false);
		if ($(".input-mobile").length && $(".input-desktop").length ) {
			changeInputNameCartPage();
			$(window).resize(changeInputNameCartPage);
		}
		$('body').on('click', '.quick', function(e){
	      	var handle = $(this).attr('data-handle');
          	var variant = $(this).attr('data-variant');
	      	quickView(handle, variant);  
	      	e.preventDefault();
	    });
	    // $('.addtocart').on('click', function(e) {        
	    //   	var productId = $(this).attr('data-id');
	    //   	Shopify.addItemFromFormStart('add-item-form', productId);
	    //   	e.preventDefault();
	    // });
	    if($('.useForm').length){
	    	var el = $('.useForm');
	    	var i;
	    	el.each(function(k,d){
				var subject = $(d).find('a').attr('href').split('#');
	        	$('#selectSubject').append('<option value="'+subject[1]+'">'+subject[1]+'</option>');
	        	if((k+1) == el.length){
	          		$('#selectSubject').parent().show();
	        	}
	    	});
	    	el.on('click', function(e){
	      		e.preventDefault();
	        	var el = $(this),
	            	link = el.find('a').attr('href').split('#');
	        	$('#selectSubject').val(link[1]);
	        	$('#inputName').focus();
	    	});
	  	}
	    
      if($('#shade-finder').length){
	    	$(window).on('load', function(){
				$('#shade-finder .models .model-list .owl-carousel').owlCarousel({
					loop:false,
				//	margin:5,
					nav:true,
                    center: true,
					lazyLoad:true,
					lazyLoadEager:2,
					items:7,
					dots:false,
					responsive:{
						0:{
							items:2
						},
						414:{
							items:2            
						},
						768:{
							items:3
						},
						812:{
							items:4,
						//	dots:true
						},
						1000:{
							items:7,
						//	dots:true
						}
					}
				});
                $('#shade-finder .models .shades-list .owl-carousel').owlCarousel({
					loop:false,
				//	margin:5,
					nav:false,
					lazyLoad:true,
					lazyLoadEager:2,
					items:7,
					dots:false,
					responsive:{
						0:{
							items:5,
                            nav:true
						},
						414:{
							items:8,
                            nav:true
						},
						768:{
							items:15,
                            nav:true
						},
						812:{
							items:23,
						//	dots:true
						},
						1000:{
							items:23,
						//	dots:true
						}
					  }
				 });
   
			});
            
            $('#shade-finder .shader.body.mobile .owl-carousel').owlCarousel({
				loop:false,
				margin:10,
				nav:false,
				lazyLoad:true,
				lazyLoadEager:2,
				items:1,
				dots:true,
				responsive:{
					0:{
						items:1
					},
					414:{
						items:1            
					},
					768:{
						items:2
					},
					812:{
						items:2,
						dots:true
					},
					1000:{
						items:1,
						dots:true
					}
				}
			});
          
	
          getCollection($('#shade-finder .selections .owl-carousel'), 'photo-finish', true, '#collnav');
            
			$('#shade-finder .model').on('click', function(e){
				
              
                const shade = $(this).attr('data-tone');
                var images = $('#shade-finder .model-list li[data-tone = '+shade+'] .image img').attr('src');
                var caption = $('#shade-finder .model-list li[data-tone = '+shade+'] .caption').text();
                var captionColor = $(this).attr('data-color');
                
                var indexActive = $(".model-list div.owl-item li.model").index(this);
                var indexLast = $("#shade-finder .model-list .owl-carousel .owl-item").length;
                
                findShade(shade, shadeMatrix, hexshadeMatrix);
                
                $("#shade-finder .shades-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);
                
                if(window.innerWidth <= 767){
                 $("#shade-finder .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);
                } 
                
                if ((window.innerWidth >= 768) && (indexActive == 0)){
                 indexActive += 3;
                 $("#shade-finder .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);
                } else if ((window.innerWidth >= 768) && ((indexActive + 1) == indexLast)){                 
                 indexActive -= 3;
                 $("#shade-finder .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);                
                } 
                
                $(".promo-selected .selected-model .image").css("background-image", 'url('+images+')');
                $(".promo-selected .selected-model .caption-bottom").css("background-color", ''+captionColor+'');
                $(".promo-selected .selected-model .caption-bottom").text(''+caption+'');
              //  var selectedBottom = '<div class="caption-bottom" style="background:'+captionColor+'">'+caption+'</div>';
              //  $(".promo-selected .selected-model .append-box").html(''+selectedBottom+'');
				
				$('#shade-finder .model, #shade-finder .shades-list li.shades').removeClass('active');
                $('#shade-finder li[data-tone = '+shade+']').addClass('active');
				e.preventDefault();
			});
           $('#shade-finder .shades-list li.shades').on('click', function(e){
				const shade = $(this).attr('data-tone');
                var images = $('#shade-finder .model-list li[data-tone = '+shade+'] .image img').attr('src');
                var caption = $('#shade-finder .model-list li[data-tone = '+shade+'] .caption').text();
                var captionColor = $('#shade-finder .model-list li[data-tone = '+shade+']').attr('data-color');    
                var indexActive = $(".shades-list div.owl-item li.shades").index(this);
                var indexLast = $("#shade-finder .model-list .owl-carousel .owl-item").length;  
                
                findShade(shade, shadeMatrix, hexshadeMatrix);
                
                $("#shade-finder .models .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);
                
                 if ((window.innerWidth >= 768) && (indexActive == 0)){
                 indexActive += 3;
                 $("#shade-finder .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);
                } else if ((window.innerWidth >= 768) && ((indexActive + 1) == indexLast)){                 
                 indexActive -= 3;
                 $("#shade-finder .model-list .owl-carousel").trigger('to.owl.carousel', [ ''+ indexActive +'' , 250]);                
                }
            
                $(".promo-selected .selected-model .image").css("background-image", 'url('+images+')');
                $(".promo-selected .selected-model .caption-bottom").css("background-color", ''+captionColor+'');
                $(".promo-selected .selected-model .caption-bottom").text(''+caption+'');
				$('#shade-finder .model, #shade-finder .shades-list li.shades').removeClass('active');
			//	$(this).addClass('active');
                $('#shade-finder li[data-tone = '+shade+']').addClass('active');
				e.preventDefault();
			});
			$(document).on('click', '.swatch a', function(e){
				var 
				el = $(this),
				title = el.attr('title'),
				src = el.attr('data-img'),
				id = el.attr('data-var_id'),
				par = el.parents('.product'),
				img = par.find('.pimage img'),
				cart = par.find('.addcart.button'),
				shade = par.find('.shadename span'),
				active = el.parents('.swatch'),
				swatches = par.find('.swatch');
				swatches.removeClass('active');
				active.addClass('active');
				shade.text(title);
				img.attr({'src':src,'alt':title});
				cart.attr('data-id',id);
				e.preventDefault();
			});
			$(document).on('click', '#shade-finder .product .addcart.button', function(e){
				var 
				el = $(this),      
				id = el.attr('data-id');
				ShopifyAPI.addItem(id,1,ajaxCart.load); 
				e.preventDefault();
			});
		}
		
       if($('.template-collection').length){
			//see if an addin banner exists in the collection description
			if($('.title-content img').length){
				//if the banner exists
				var banner = $('.title-content img'),
					bannerSet = [];

				banner.each(function(el){
					var el = $(this),
						bitem,
						copy,
						pack,
						kind;						
						if(el.parent().is('a')){
							bitem = el.parent();
							copy = $('<div />').append($(bitem).clone()).html();
							pack = $('<div class="pitem mobpad col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">'+copy+'</div>');
							kind = 'addin';
						} else {
							bitem = el;
							copy = $('<div />').append($(bitem).clone()).html();
							pack = $('<div class="mobilemain">'+copy+'</div>');
							kind = 'fallback';
						}					
					bannerSet.push({el:pack,type:kind});
				});				
				var products = $('.product-listing .pitem');

				bannerSet.forEach( function(element, index) {
					// statements
					if(element.type == 'addin'){
						products.eq(2).after(element.el);
					}
					if(element.type == 'fallback'){
						$('.title-box').append(element.el);
					}
				});
				
			}
		}
		$('.search a.search__open').on('click', function(e){
			var drop = $('.search-dropdown');
			if(drop.hasClass('open')){
				drop.hide();
			} else {
				drop.show();
				drop.addClass('open');
			}
			e.preventDefault();
		});
	});
  
    window.productCarousel = productCarousel;
	window.mobileOnlyCarousel = mobileOnlyCarousel;
	window.listingModeToggle = listingModeToggle;
	window.elevateZoom = elevateZoom;
	window.elevateZoom1 = elevateZoom1;
	window.sliderNoZoom = sliderNoZoom;

	 function attachEvent(){
          //    $("#shade-finder .shades-list li.shades:first-child").click();
              console.log("event");
            }
  
  // Sections and Blocks
	function sectionReady(){
		var section = $('.section-box').parent();		
		$.each(section, function(i,el){			
			var target = $(el),
				type = target.find('.section-box').attr('data-section-type');
			switch(type){
				case 'owl-section':					
					slider(target);
					break;
				default:
					// console.log('out');
			}
		});		
	}

	function sectionEdit(event){
		var target = $(event.target),
		type = target.find('.section-box').attr('data-section-type');
		switch(type){
			case 'owl-section':
				slider(target);
				break;
			default:
				// console.log('out');
		}
	}

	function blockEdit(event){
		var target = $(event.target),
		data = target.data(),
		blockType = data[Object.keys(data)[0]].type,
		eventType = event.type || null;
		switch(blockType){
			case 'slider_list':
				goTo(target, eventType);
				break;
			default:
				// console.log('out');
		}
	}

	function slider(target){
		var slider = target.find('.owl-carousel'),
		timer = slider.attr('data-timer');
		slider.owlCarousel({
			loop:true,
			items:1,
			margin:0,
			nav:true,
			autoplay: true,
			autoplayTimeout: timer,
			navText:['',''],
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
	}
	function goTo(target, eventType){
		var block = $(target),
		pos = block.parent().index(),
		slider = block.parents('.owl-carousel');		
		slider.trigger('to.owl.carousel',[pos,0]);
		slider.trigger('stop.owl.autoplay');
		if(eventType === 'shopify:block:deselect') {
			slider.trigger('play.owl.autoplay');
		}
	}
	// End Sections and Blocks

	// Tools	
	function promobar(){
		$('.promotion_bar .owl-carousel').owlCarousel({
    		loop:true,
    		margin:0,
    		nav:true,    		
    		dots:false,
    		items:1,
    		autoplay:true,
    		autoplayTimeout:4000,
    		autoplayHoverPause:true,
    		navContainer:'#promobar'
  		});
	}
	function menu(){		
		$("nav").each(function(){
			if(!$( this ).hasClass("navbar-vertical")) {
				$( this ).find(".dropdown:not(.no-megamenu-js)").each(function(){
				$( this ).hover(
					function() {
						var $this = $( this );
						var $obj = $this.find(".dropdown-menu");
						if($obj.length) {
							$obj.fadeOut(0);
							timerVar = setTimeout(function(){ 
								$this.addClass("active"); 
								$obj.fadeIn(200);
								submenuXposition($obj);
								submenuYposition($obj);
								$( window ).bind( "scroll", { obj: $obj }, menuScroll);
							}, 300);
						}
					}, function() {
						var $this = $( this );
						var $obj = $this.find(".dropdown-menu");
						clearTimeout(timerVar);
						$( window ).unbind( "scroll", menuScroll);
						if($this.hasClass("active")){
							$obj.fadeOut(300);
							setTimeout(removeActiveItem, 300, $this);
							$( "body" ).hasClass("hidden-menu") && $( "body" ).removeClass("hidden-menu");
						}
					});
				});
			}
		});
		function submenuXposition($obj){
			var w_width = window.innerWidth;
			var o_position = $obj.offset().left;
			var o_width = $obj.outerWidth();
			var delta = parseInt(w_width - o_position - o_width - 25);
			if(delta < 0) {
				$obj.css("left", delta);
			}
		}
		function submenuYposition($obj){
			var w_height = window.innerHeight;
			var o_position = $(".stuck-nav").hasClass("fixedbar") ? $obj.position().top : $obj.offset().top;
			var o_height = $obj.outerHeight();
			var delta = parseInt(w_height - o_position - o_height);
			if(delta < 0) {
				$obj.css({"max-height": o_height + delta - 25, "overflow": "auto"});
				$( "body" ).addClass("hidden-menu");
			}
		}
		function menuScroll(event) {
			event.data.obj.removeAttr("style");
			submenuXposition(event.data.obj);
			submenuYposition(event.data.obj)
		}
		function removeActiveItem(item){
			item.removeClass("active");
			item.removeAttr("style");
			item.find("ul").first().removeAttr("style");
		}
		if($( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).length) {
			$( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).parent().addClass("selected");
		}
	}

	function stuckNav(){		
		var navHeight = $('.header-wrapper').outerHeight();
		$('.superspace').css('height',navHeight);		
		$(window).resize(function(){			
			setTimeout(function(){
				var navHeight = $('.header-wrapper').outerHeight();
				// console.log(navHeight);
				$('.superspace').css('height',navHeight);
			}, 250);			
		});		
	}

	function navbarClick() {
    	var windowW = window.innerWidth || $(window).width();
		// mobile menu off width
		if (windowW > 1025) {
			$('.navbar .dropdown > a').on('click', function(){
				location.href = this.href;
				return false
			});
		}
		if (windowW > 1025 && $('html').hasClass('touch')) {
			$('.navbar .dropdown > a').on('click', function(e){
				var attr = $(this).attr('aria-expanded');
				if(attr == "true"){
					location.href = this.href;
					return false
				}
			});
		}
	}

	function mobileNav(){
		if ($(".navbar-toggle").length > 0) {
			$('.navbar-toggle').click(function () {
				$(".mobile-menu-wrapper").addClass('open');
				$("body").addClass('no-scroll');        
			});  
			$('#cboxClose').click(function () {
				$('.mobile-menu-wrapper, .mobile-menu-popup').removeClass('open');
				$("body").removeClass('no-scroll')
			});
			$('.mobile-menu-popup').click(function () {
				$('.mobile-menu-wrapper').removeClass('open');
				$("body").removeClass('no-scroll')
			});         
		} 
		$("#off-canvas-menu .expander-list").find("ul").hide().end().find(" .expander").text("+").end().find(".active").each(function() {
			$(this).parents("li ").each(function() {
				var $this = $(this),
				$ul = $this.find("> ul"),
				$expander = $this.find("> .name .expander");
				if($ul.length){
					$ul.show();
					$expander.html("&minus;")	
				}				
			});
		}).end().find(" .expander").each(function() {
			var $this = $(this),
			hide = $this.text() === "+",
			$ul = $this.parent(".name").next("ul"),
			$name = $this.next("a");			
			$this.click(function() {
				if ($ul.css("display") == "block"){
					$ul.slideUp("slow");
				} else {
					$ul.slideDown("slow");
					$(this).html(hide ? "&minus;" : "+");             
					hide = !hide;
				}
			});
		});
		$("#off-canvas-menu .expander-list > li").each(function(){
			var el = $(this);
			if(el.find(' > .multicolumn-level').length){

			} else {
				el.find('.expander').hide();
			}
		});		
	}

	function expanderList() {
		$('.expander-list .expander').each(function() {
			if ($(this).parent('li').hasClass('active')){
				$(this).next('ul').slideDown(0);
				$(this).parent().addClass('open');
			}
		});
		$(".expander-list .expander").on('click', function(e) {
			e.preventDefault();
			var speed = 300;
			var thisItem = $(this).parent(),
			nextLevel = $(this).next('ul');
			if (thisItem.hasClass('open')){
				thisItem.removeClass('open');
				nextLevel.slideUp(speed);
			} else {
				thisItem.addClass('open');
				nextLevel.slideDown(speed);
			}
		});
	}

	function collapseBlock() {
		$('.collapse-block__content').each(function() {
			if ($(this).parent('.collapse-block').hasClass('open')){
				$(this).slideDown(0);
			}
		});
		$('.collapse-block__title').on('click', function(e) {
			e.preventDefault();
			var speed = 300;
			var thisItem = $(this).parent(),
			nextLevel = $(this).next('.collapse-block__content');
			if (thisItem.hasClass('open')){
				thisItem.removeClass('open');
				nextLevel.slideUp(speed);
			} else {
				thisItem.addClass('open');
				nextLevel.slideDown(speed);
			}
		});
	}	

	function listingModeToggle() {    
		$('a.link-row-view').on('click', function(e) {
			e.preventDefault();
			$(this).addClass('active');
			$('a.link-grid-view').removeClass('active');
			$('.product-listing').addClass('row-view');
		});		
		$('a.link-grid-view').on('click', function(e) {
			e.preventDefault();
			$(this).addClass('active');
			$('a.link-row-view').removeClass('active');
			$('.product-listing').removeClass('row-view');
		});
	}

	function backToTop(){
		if ($(".back-to-top").length > 0) {
			$('.back-to-top').on('click', function(e){
				$('html, body').animate({scrollTop: 0},500);
				e.preventDefault();
			});
			$(window).scroll(function () {
				if($(window).scrollTop() > 500){
					$(".back-to-top").addClass('fadein');
				} else {
					$(".back-to-top").removeClass('fadein');
				}
			});
		} 
	}

	function productCarousel(carousel,nav){    
		var showNav = false;
		if(nav){
			showNav = true;
		}
		carousel.each(function(i, el){
			var elem = $(el);      
			elem.owlCarousel({
				loop:true,
				margin:0,
				nav:showNav,
				dots:false,
				mouseDrag:false,
				touchDrag:false,
				pullDrag:false,
				lazyLoad:true,
				lazyLoadEager:2,
				items:1
			});
		});    
	}

	function mobileOnlyCarousel() {
		var windowW = window.innerWidth || $(window).width();
		var carouselMobileOnly = $('.carousel-products-mobile');
		if (windowW < 480) {
			carouselMobileOnly.each(function(){
				if (!$(this).hasClass('slick-initialized')){
					$(this).slick({
						slidesToShow: 1,
						slidesToScroll: 1
					});
				}
			});
		}
		$(window).resize(debouncer(function(e) {    
			var currentW = window.innerWidth || $(window).width();
			var carouselMobileOnly = $('.carousel-products-mobile');
			if (currentW < 480) {
				if(carouselMobileOnly && carouselMobileOnly.length) {
					carouselMobileOnly.slick({
						slidesToShow: 1,
						slidesToScroll: 1
					});
				}
			} else {
				if (carouselMobileOnly.hasClass('slick-initialized')){
					carouselMobileOnly.slick('unslick');
				}
			}
		}));
	}

	function elevateZoom() {
		var windowW = window.innerWidth || document.documentElement.clientWidth;
		$('.product-zoom').imagesLoaded(function() {
			if ($('.product-zoom').length) {
				var zoomPosition
				if ( $('html').css('direction').toLowerCase() == 'rtl' ) {
					zoomPosition = 11;
				} else {
					zoomPosition = 1
				}
				if (windowW > 767) {
					$('.product-zoom').elevateZoom({	
						zoomWindowWidth: $('.product-zoom').width()- 60,
						zoomWindowHeight: $('.product-zoom').width() - 60,
						gallery: "smallGallery",
						galleryActiveClass: 'active',
						zoomWindowPosition : zoomPosition
					});
				} else {
					$(".product-zoom").elevateZoom({
						gallery: "smallGallery",
						zoomType: "inner",
						galleryActiveClass: 'active',
						zoomWindowPosition : zoomPosition
					});
				}
			}
		});
		$('.product-main-image > .product-main-image__zoom ').bind('click', function(){
			galleryObj = [];
			current = 0;
			itemN = 0;    
			if ($('#smallGallery').length){
				$('#smallGallery li a').not('.video-link').each(function() {
					if ($(this).hasClass('active')) {
						current = itemN;
					}
					itemN++;
					var src = $(this).data('zoom-image'),
					type = 'image';
					image = {};
					image ["src"] = src;
					image ["type"] = type;
					galleryObj.push(image);
				});
			} else {
				itemN++;
				var src = $(this).parent().find('.product-zoom').data('zoom-image'),
				type = 'image';
				image = {};
				image ["src"] = src;
				image ["type"] = type;
				galleryObj.push(image);
			}
			$.magnificPopup.open({
				items: galleryObj,
				gallery: {
					enabled: true,
				}
			}, current);   
		});
		var  prevW = windowW;
		$(window).resize(debouncer(function(e) {
			var currentW = window.innerWidth || $(window).width();
			if (currentW != prevW) {
				// start resize events
				$('.zoomContainer').remove();
				$('.elevatezoom').removeData('elevateZoom');
				if ($('.product-zoom').length) {
					if (currentW > 767) {
						$('.product-zoom').elevateZoom({
							zoomWindowHeight: $('.product-zoom').height(),
							gallery: "smallGallery"
						});
					} else {
						$(".product-zoom").elevateZoom({
							gallery: "smallGallery",
							zoomType: "inner"
						});
					}
				}    
				// end resize events  
			}
			prevW = window.innerWidth || $(window).width();
		}));
	}

	function elevateZoom1() {
		var currentW = window.innerWidth || $(window).width();
		if (currentW > 767) {
			if ($('.product-zoom1').length) {
				$('.product-zoom1').elevateZoom({
					zoomType: "inner",
					cursor: "crosshair",
					zoomWindowFadeIn: 300,
					zoomWindowFadeOut: 300
				});
			}
		}
	}

	function sliderNoZoom(){
		if ($(".slider-no-zoom").length > 0) {
			$('.slider-product-large').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				centerPadding: '40px',
				infinite: true,
				asNavFor: '.slider-product-small'
			});
			$('.slider-product-small').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				asNavFor: '.slider-product-large',
				dots: true,
				centerPadding: '40px',
				focusOnSelect: true
			});
		}
	}

	function changeInputNameCartPage() {
		var name= "updates[]";
		if ($(window).width() > 767) {
			$(".input-mobile").attr("name", "");
			$(".input-desktop").attr("name", name);
		} else {
			$(".input-mobile").attr("name", name);
			$(".input-desktop").attr("name", "");
		}
	}

	function debouncer(func, timeout) {
		var timeoutID, timeout = timeout || 500;
		return function() {
			var scope = this,
			args = arguments;
			clearTimeout(timeoutID);
			timeoutID = setTimeout(function() {
				func.apply(scope, Array.prototype.slice.call(args));
			}, timeout);
		}
	}

  	function quickView(handle, varSelect){
    	var loader = (function(){ $('.loader').show(); })(),
        varSelect = varSelect || null,
    	product = null,
    	getProduct = $.getJSON('/products/'+handle+'.js').done(function(json){ return json; }),
    	productData = getProduct.then(function(data){ product = data; }),
    	buildFrame = function(el){
      		var str = '';
			str += '<div id="quickShop">',      
			str += '<div class="inner">',
			str += '<div class="closer overlay"></div>',      
			str += '<div class="hold">',
			str += '<div class="closer overlay"></div>',     
			str += '<div class="wrapper">',      
			str += el,
			str += '</div>',
			str += '</div>',
			str += '</div>',
			str += '</div>';
			return str;
    	},
    	buildInner = function(product){
    		// console.log(product);
			var str = '',
			id = product.id,
			title = product.title,
			handle = product.handle,
			variants = product.variants;
			str += '<div class="cells left">',
			str += '<ul class="images owl-carousel owl-theme">',      
			str += '</ul>',
			str += '</div>',
			str += '<div class="cells right">',
			str += '<div class="closer">X</div>',
			str += '<div class="notif">Free Shipping on Orders $35+</div>',
			str += '<h1>'+title+'</h1>';
			str += '<div class="revs"><span class="shopify-product-reviews-badge" data-id="'+id+'"></span></div>';
			if(variants.length > 1){
				str += '<div class="avail">'+variants.length+' Shades Available</div>';  
			}         			
			str += '<div class="shade hov"></div>',      
			str += '<div class="getter" data-id="'+id+'">',
			str += '<form id="add-item-form" action="/cart/add" method="post">',
			str += '<input type="hidden" value="'+variants[0].id+'" name="id"/>',
			str += '<div class="high">';
			if(variants[0].title != "Default Title"){
				str += '<h2 data-current="'+variants[0].title+'">Shade: <span>'+variants[0].title+'</span></h2>';
			} else {
				str += '';
			}	
			str += '<div class="price"><span class="current">$<span>'+Shopify.formatMoney(variants[0].price, '{{amount}}')+'</span></span>';
			if(variants[0].compare_at_price != null){
				str += '<span class="price-box__old">$<span>'+Shopify.formatMoney(variants[0].compare_at_price, '{{amount}}')+'</span></span>';	
			} else {
				str += '<span class="price-box__old hide">$<span></span></span>';
			}						
			str += '</div>',
			str += '<select name="quantity">';
      		for(var i = 0; i < 6; i++){
        		var val = i + 1;
        		str += '<option value="'+val+'">'+val+'</option>';  
      		}
			str += '</select>',
			str += '</div>',
			str += '<ul class="variants">';
			for(var i=0; i < variants.length; i++){
				var first = '';        
				var price = variants[0].price;
				var sku = variants[i].sku,
				sku = sku.replace(' ','zz'),
				sku = sku+'s',
				src = product.images[0];
				src = src.split('product');
				src = src[0];        
				src = src+'files/'+sku+'.jpg';
				if(i == 0){
					first = 'active';
				}
				if(variants.length > 2){
					str += '<li class="'+first+'" data-id="'+variants[i].id+'" data-price="'+Shopify.formatMoney(variants[i].price, '{{amount}}')+'" data-compare="'+Shopify.formatMoney(variants[i].compare_at_price, '{{amount}}')+'" data-title="'+variants[i].title+'" data-available="'+variants[i].available+'">';        
					str += '<img src="'+src+'" alt="'+variants[i].title+'"/>';
					str += '</li>';
        		}        
      		}
			str += '</ul>',
			str += '<div class="low">';
			if(variants[0].available){
				str += '<button type="submit" class="addtocart">Add to Cart</button>';	
			} else {
				str += '<button type="submit" class="addtocart" disabled>Unavailable</button>';
			}
	        if(varSelect) {
      			var variant = varSelect;
              	str += '<div class="more"><a href="/products/'+handle+'/?variant='+variant+'">View Full Details</a></div>';
            } else {
            	str += '<div class="more"><a href="/products/'+handle+'/">View Full Details</a></div>';
            }			
			str += '</div>',
			str += '</form>',
			str += '</div>',      
			str += '</div>';
			return str;
		},
		getImages = function(variant){
			var str = '',
			variant = variant.toLowerCase().trim(),
			images = product.variants,
			images = images.filter(function(img){				
				if(img.featured_image === null) return;
				if(img.featured_image.alt === null) return;
				var alt = img.featured_image.alt.toLowerCase().trim();
				return alt === variant;
			});			
			if(images.length > 0){
				for(var i=0; i < images.length; i++){        
					str += '<li>',
					str += '<img class="owl-lazy" data-src="'+images[i].featured_image.src+'" alt="'+images[i].featured_image.alt+'"/>',
					str += '</li>';
				}
			}
			if(str == ''){
				str += '<li>',
				str += '<img class="owl-lazy" data-src="'+product.featured_image+'"/>',
				str += '</li>'; 
			}
			return str;
    	},
		setVar = function(id,name){
			var id = id,
			name = name;
			$('#quickShop h2 span').text(name);
			$('#quickShop input[name="id"]').val(id);
    	},
    	setGal = function(name){
			var gal = getImages(name);
			$('#quickShop .images').trigger('destroy.owl.carousel');
			$('#quickShop .images').html(gal).owlCarousel({
				loop:true,
				margin:0,
				nav:false,
				lazyLoad:true,
				lazyLoadEager:2,
				items:1
			});
    	},
    	bindVariant = function(){
      		$('#quickShop .variants li').on('click', function(){
        		var el = $(this),
        		id = el.attr('data-id'),
        		name = el.attr('data-title'),
        		price = el.attr('data-price'),
        		compare = el.attr('data-compare'),
        		available = el.attr('data-available');
        		$('#quickShop .variants li').removeClass('active');
        		el.addClass('active');
        		$('#quickShop h2').attr('data-current', name);
        		$('#quickShop .price .current span').text(price);
        		if(compare != '0'){
        			$('#quickShop .price-box__old span').text(compare);
        			$('#quickShop .price-box__old').removeClass('hide');
        		} else {
        			$('#quickShop .price-box__old').addClass('hide');
        		}
        		if(available == 'false'){
        			$('#quickShop .inner .right .low button').attr('disabled', true).text('Unavailable');
        		} else {
        			$('#quickShop .inner .right .low button').attr('disabled', false).text('Add to Cart');
        		}
        		setVar(id, name);
        		setGal(name);
      		});
    	},
    	bindAdd = function(){
      		$('#quickShop form').on('submit', function(e){
        		var id = $('#quickShop .getter').attr('data-id');
        		ShopifyAPI.addItemFromForm('#quickShop form',ajaxCart.load);
        		e.preventDefault();
      		});
    	},
    	bindCloser = function(){
      		$('#quickShop .closer').on('click', function(){
        		$('#quickShop').fadeOut('fast', function(){
          			$('#quickShop .images').trigger('destroy.owl.carousel');
          			$('#quickShop .variants li').off();
          			$(this).remove();
        		});  
      		});
    	},
    	bindHover = function(){
      		$('#quickShop .variants li').mouseenter(function(event){     
        		var el = $(this),
        		name = el.attr('data-title'),
        		shade = $('#quickShop h2');
        		shade.text(name);     
      		});
      		$('#quickShop .variants').mouseleave(function(event){        
        		var shade = $('#quickShop h2'),
        		name = shade.attr('data-current');
        		shade.text(name);     
      		});
    	},
    	buildView = productData.then(function(){
      		var inner = buildInner(product),
          		frame = buildFrame(inner),
          		gal = product.variants[0].title;
      		$('body').append(frame);      
      		$('#quickShop').fadeIn('330', function(){
        		$('.loader').hide();
      		});
      		if(typeof SPR != "undefined"){
      			SPR.initDomEls();
      			SPR.loadBadges();	
      		}      		
      		return gal;
    	}), 
    	init = buildView.then(function(gal){
      		setGal(gal),
      		bindVariant(),
      		// bindHover(),
      		bindAdd(),  
      		bindCloser();
          	if(varSelect) {
      			var variant = varSelect;
      			$('#quickShop .variants li[data-id="'+variant+'"]').trigger('click');
      		}
    	});
    	return init;
  	}

	function getCollection(elem, handle, showNav, navEl){
    	var
	    // loader = (function(){
	    //   $('.loader').fadeIn(330);
	    // })(),
	    shandle = handle || '',
	    matrix = matrix || {},
	    shadecont = elem || null,
	    useNav = showNav || true,
	    products = [],
	    collection = $.getJSON('/collections/'+shandle+'/products.json').done(function(data){
      		products = data.products;
      		return products;
    	}),
    	buildProduct = function(product){
      		var 
      		id = product.id,
			title = product.title,
			phandle = product.handle,
			variants = product.variants,
			vtitle = variants[0].title,
			vimage = variants[0].featured_image || product.images[0],
			vimage = vimage.src,
			vprice = variants[0].price,
			vid = variants[0].id,
			str = '';
			str += '<div class="product"><div class="inner">',
			str += '<div class="pimage"><div class="colimage">',
			str += '<a href="/collections/'+shandle+'/products/'+phandle+'/"><img src="'+vimage+'" alt="'+vtitle+'"></a>',
			str += '</div></div>',
			str += '<div class="pdescription">',
			str += '<div class="pname"><h2 class="ptitle"><a href="/collections/'+shandle+'/products/'+phandle+'/">'+title+'</a></h2></div>';      
			if(variants.length > 1){
				str += '<div class="shadename"><p>'+variants.length+' Shades Available</p></div>';  
			}
			str += '<div class="pmid"><div class="baseprice"><span><span class="money">$'+vprice+'</span></span></div></div>';
			str += '</ul></div></div>',
			str += '<div class="btnhold"><a href="#" class="quick button" data-handle="'+phandle+'">Shop Now</a></div>',
			str += '</div>',
			str += '</div></div>';
			return str;
    	},
    	buildMatch = function(products){
      		var 
      		str = '',
      		products = products;      
      		products.forEach(function(product){
        		var product = buildProduct(product);
        		str += '<li>'+product+'</li>';
      		});
      		return str;
    	},
    	updateRevs = function(build){
      		shadecont.html(build);
      	//	 SPR.initDomEls();
      	//	 SPR.loadBadges();
      		return shadecont;
    	},
    	addSlider = function(build){
      		shadecont.trigger('destroy.owl.carousel');
      		updateRevs(build).owlCarousel({
        		loop:false,
        		margin:20,
        		nav:true,
        		lazyLoad:true,
        		lazyLoadEager:2,
        		dots:true,
        		items:4,
        		navContainer:navEl,
        		responsive:{
	          		0:{
	            		items:1
	          		},
	          		414:{
	            		items:1              
	          		},
	          		768:{
	            		items:3
	          		},
	          		812:{
	            		items:3
	          		},
	          		1000:{
	            		items:4,
	            		dots:false,
	            		nav:useNav
	          		}
	        	}
      		});
    	},
    	create = collection.done(function(){
      		var build = buildMatch(products);        
      		addSlider(build);      
    	}),
    	init = create.then(function(){
      		$('.loader').fadeOut('330');
      		$('.load').hide();
    	}),
    	errors = init.fail(function(){
      		$('.loader').fadeOut('330');
      		$('.load').hide();
      		alert('Something went wrong.');
    	});        
    	return errors;
  	}

  	function findShade(handle, matrix, hexshadeMatrix){
    	var
    	loader = (function(){ $('.loader').fadeIn(330); })(),
    	shandle = handle || '',
    	matrix = matrix || {},
        hexshadeMatrix = hexshadeMatrix || {},    
    	shadecont = $('#shade-finder .match .owl-carousel'),
    	products = [],
    	collection = $.getJSON('/collections/'+shandle+'/products.json').done(function(data){
      		products = data.products;
      		return products;
    	}),
    	buildProduct = function(product,productIndex){
      		var 
      		id = product.id,
      		title = product.title,
      		phandle = product.handle,
      		variants = product.variants,
      		variants = variants.filter(function(item){
        		return matrix[shandle].includes(item.title);
      		}),

             
     		vtitle = matrix[shandle][productIndex];
            
            
          
            var variantsHexs = hexshadeMatrix[shandle];
            var vhexcode = variantsHexs[productIndex];

      		if(variants?.length && variants[0].featured_image != null){
        		var vimage = variants[0].featured_image.src;
      		} else {
        		var vimage = product.images[0].src;
      		}

            var vprice;
            if (variants?.length && variants[0].price){
        		vprice = variants[0].price;
            }

            var vid;
            if (variants?.length && variants[0].id){
        		vid = variants[0].id;
            }          
            
			var str = '';
			str += '<div class="product"><div class="inner">';
            
            if(vtitle != 'Invisible' && vtitle != 'Default Title'){
              str += '<div class="shadename"><p><span class="shade-color" style="background:'+vhexcode+'"></span><span>'+vtitle+'</span></p></div>';
            }else{
              str += '<div class="default-title-hidden"></div>';
            }            
            
			str += '<div class="pimage"><div class="colimage">',
			str += '<a href="/collections/'+shandle+'/products/'+phandle+'/"><img src="'+vimage+'" alt="'+vtitle+'"></a>',
			str += '</div></div>',
			str += '<div class="pdescription">',
			str += '<div class="pname"><h2 class="ptitle"><a href="/collections/'+shandle+'/products/'+phandle+'/">'+title+'</a></h2></div>',      
			str += '<div class="pmid"><div class="revs"><div class="rating"><span class="shopify-product-reviews-badge" data-id="'+id+'"></span></div></div><div class="baseprice"><span><span class="money">$'+vprice+'</span></span></div></div>';
            
			
      		str += '<div class="shadeholder"><div class="pinfo"><ul class="swatches">';
      		for(var i=0; i < variants.length; i++){
        		var 
				v = variants[i],
				title = v.title,
				id = v.id,
				pid = v.product_id,
				price = v.price,
				sku = v.sku,
				sku = sku.replace(' ','zz'),
				sku = sku+'s';
				if(v.featured_image != null){
					var src = v.featured_image.src;
				} else {
					var src = product.images[0].src;
				}        
				var srcsku = src.split('products'),
				srcsku = srcsku[0],
				srcsku = srcsku+'files/'+sku+'.jpg';
				if(matrix[shandle].includes(title) && title != 'Invisible' && title != 'Default Title'){
					var 
					avail = '',
					active = '';
					if(v.available == true){
						avail = ' available';
					}
					if(i == 0){
						active = ' active';
					}
					str += '<li data-value="'+title+'" class="swatch'+avail+active+'"><a href="#" title="'+title+'" data-pr_id="'+pid+'" data-img="'+src+'" data-var_id="'+id+'" data-price="'+price+'"><img src="'+srcsku+'" alt="'+title+'"></a></li>';  
				}        
			}
			str += '</ul></div></div>',
			str += '<div class="btnhold"><a href="/collections/'+shandle+'/products/'+phandle+'/" class="addcart button" data-id="'+vid+'">Get It</a></div>',
			str += '</div>',
			str += '</div></div>';
			return str;
    	},
    	buildMatch = function(products){
      		var 
      		str = '',
      		products = products;      
      		products.forEach(function(product, productIndex){	
              var product = buildProduct(product,productIndex);
              str += '<li>'+product+'</li>';
      		});
      		return str;
    	},
    	updateRevs = function(build){
      		shadecont.html(build);
            if(typeof SPR != "undefined"){          
        		SPR.initDomEls();
        		SPR.loadBadges();
            }
      		return shadecont;
    	},
    	addSlider = function(build){
      		shadecont.trigger('destroy.owl.carousel');
      		updateRevs(build).owlCarousel({
        		loop:false,
        		margin:10,
        		nav:true,
        		lazyLoad:true,
        		lazyLoadEager:2,
        		dots:false,
        		items:4,
        		navContainer:'#matnav',
        		responsive:{
          			0:{
            			items:1
          			},
          			414:{
            			items:1         
          			},
          			768:{
            			items:1
          			},
          			812:{
            			items:1
          			},
                    992:{
            			items:2
          			},
          			1100:{
            			items:3,
            			dots:false
          			}
        		}
      		});
    	},
    	create = collection.done(function(){      
      		var build = buildMatch(products);        
      		addSlider(build);      
    	}),
    	init = create.then(function(){
      		$('.loader').fadeOut('330');
      		$('#shade-finder .match').slideDown(330);      
      		$('#shade-finder .head').addClass('active');
    	}),
    	errors = init.fail(function(){
      		$('.loader').fadeOut('330');
      		alert('Something went wrong.');
    	});        
    	return errors;
  	}

  	function videoPlay(){
  		$('.videoPlay').on('click', function(e){
  			var playing = $('.videoPlay .img iframe'),
  			el = $(this),
  			newVideo = el.find('.img .hold'),
  			id = el.attr('data-id'),
  			frame = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+id+'?rel=0&autoplay=1&vq=hd1080" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
  			playing.remove();
  			newVideo.append(frame);
  			e.preventDefault();
  		});
  	}

  	function noellaPlay(){
  		$('.playback').on('click', function(e){
  			var el = $(this),
  			id = el.attr('data-id'),
  			parent = el.parents('.prime-banner'),
  			holder = parent.find('.video-content'),
  			video = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+id+'?rel=0&autoplay=1&vq=hd1080" frameborder="0" allowfullscreen="1" scrolling="no" allow="autoplay; encrypted-media"></iframe>';
  			if(id){
  				holder.html(video).fadeIn('330');	

  			}  			
  			e.preventDefault();
  		})
  	}

  	function setReviews(){
		if($(window).width() > 767){
			if($('.add_review').length > 0){
				$('.add_review').click(function(e){
					$('#nav-tabs--ys li a').each(function(){
						if($(this).text().trim() == 'REVIEWS'){        
							$(this).trigger('click');
						}
					});
					if($(window).scrollTop() > HeaderTop){
						var headerHeight = $('.stuck-nav').height();
					}else{
						var headerHeight = $('.stuck-nav').height() + $('.custum_header').height();
					}
					$('html, body').animate({
						scrollTop: $(jQuery(this).attr('href')).offset().top - headerHeight
					}, 2000);
					e.preventDefault();
				});
			}
		}
		else{
			if($('.add_review').length > 0){
				$('.add_review').click(function(e){					
					var headerHeight = $('.stuck-nav').height() + 70;        
					$('.desktop-hidden.custm_mob_tab .mob-heading').each(function(){
						if($(this).text().trim() == 'REVIEWS'){ 
							$('html, body').animate({
								scrollTop: $('#shopify-product-reviews').offset().top - headerHeight
							}, 2000);
						}
					});
					e.preventDefault();
				});
			}      
		}
  	}
	
	function ALAcheck() {
		isALARendered = setInterval(function () {
			customALA();
		}, 200);
	}
	function customALA() {
		if(jQuery('.product-info__review .spr-badge-caption').length > 0) {
			clearInterval(isALARendered);    
			jQuery('.product-info__review .spr-badge-caption').click(function(e){				
				jQuery('.add_review').trigger('click');
				e.preventDefault();
			});
			if(window.location.href.indexOf("#shopify-product-reviews") > -1) {
				jQuery('.add_review').trigger('click');          
			}
		}              
	}
	// End Tools

})(jQuery, window);